function convertISOToNormalDate(isoDate: string): string {
  const date = new Date(isoDate);

  // Format the date
  const formattedDate = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;

  // Format the time
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const formattedTime = `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;

  // Combine the formatted date and time
  const convertedDate = `${formattedDate} ${formattedTime}`;

  return convertedDate;
}

export default convertISOToNormalDate;
